import api from './api';

const petBreedsService = {
  getAll: async () => {
    const response = await api.get('/pet-breed/get-pet-breed');
    return response.data.data || response.data;
  },

  getByType: async (typeId) => {
    const response = await api.get(`/pet-breed/get-type/${typeId}`);
    return response.data.data || response.data;
  },

  create: async (data) => {
    const response = await api.post('/pet-breed/add-pet-breed', data);
    return response.data.data || response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/pet-breed/update-pet-breed/${id}`, data);
    return response.data.data || response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/pet-breed/delete-pet-breed/${id}`);
    return response.data;
  },
};

export default petBreedsService;
